module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cabeceraadmin/cabeceraadmin.component.scss
// module id = ./src/app/cabeceraadmin/cabeceraadmin.component.scss
// module chunks = main